import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Books = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddBook = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditBook = () => {
  return (
    
      
        <Edit />
      
    
  );
};
